import { Button } from "antd";
import { GetAntIcon } from "../../utils/ant_icons";

interface ReportEditButtonProps {
	label: string;
	onClick: () => void;
	// A link on a dark header bar; "default" gives an outlined button.
	type?: "link" | "default";
}

function ReportEditButton(props: Readonly<ReportEditButtonProps>) {
	const { label, onClick, type = "link" } = props;

	return (
		<Button type={type} icon={GetAntIcon("edit")} onClick={onClick}>
			{label}
		</Button>
	);
}

export default ReportEditButton;
